// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-container[data-v-72a3e6cc] {\n  border: 1px solid var(--v-greyMedium-base);\n  border-radius: 12px;\n  cursor: pointer;\n}\n@media (min-width: 960px) {\n.overview-container-my-blocks[data-v-72a3e6cc] {\n    min-height: 74px;\n}\n}", ""]);
// Exports
module.exports = exports;
